import { useAppUser } from '../auth/AppUserContext';
import { canExportCsv, csvFileName, downloadCsv, type CsvCell } from './csv';

/**
 * "Download CSV" (B6, owner rulings 2026-10-25) — for DM / Auditor / Admin
 * / Executive (effective role); renders nothing for anyone else. `rows`
 * is built on click from what the table is showing (its filters applied).
 */
export function CsvButton({
  name,
  header,
  rows,
  label = 'Download CSV',
}: {
  /** File name part: "board" → auditplus-board-2026-10-25.csv */
  name: string;
  header: readonly string[];
  rows: () => readonly (readonly CsvCell[])[];
  label?: string;
}) {
  const { user } = useAppUser();
  if (!canExportCsv(user?.role)) return null;
  return (
    <button
      type="button"
      className="btn btn-small csv-button"
      aria-label={`Download ${name} as CSV`}
      onClick={() => downloadCsv(csvFileName(name), header, rows())}
    >
      ⬇ {label}
    </button>
  );
}
